(() => {
  const hosts = new WeakSet();
  function connect() {
    document.querySelectorAll('.drp-anniversary__entry shopify-forms-embed').forEach(host => {
      if (hosts.has(host) || !host.shadowRoot) return;
      hosts.add(host);
      const root = host.shadowRoot;
      const update = () => host.toggleAttribute(
        'data-drapeur-success',
        Boolean(root.querySelector('[data-testid="banner-success"]'))
      );
      const observer = new MutationObserver(() => {
        if (!host.isConnected) {
          observer.disconnect();
          return;
        }
        update();
      });
      observer.observe(root, {childList: true, subtree: true});
      update();
    });
  }
  customElements.whenDefined('shopify-forms-embed').then(() => {
    connect();
    new MutationObserver(connect).observe(document.body, {childList: true, subtree: true});
  });
})();
